import { useEffect, useState } from 'react'
import StateDrawer from '../drawer/StateDrawer';
import PrivateHeader from '../header/privateHeader/PrivateHeader'
import Notification from '../../components/stateful/notification/Notification';
import './PrivatePageLayout.scss'
// redux
import { useNotificationHelper } from '../../utilities/helpers/NotificationHelper';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { validateUserRoles } from '../../features/state/StateAuthRole-slice';
// import Authorized from '../../components/stateful/authorized/Authorized';
import RulesPage from '../../pages/public/rules/Rules';

interface IPrivatePageLayout {
    children: any;
}


const PrivatePageLayout = (props: IPrivatePageLayout) => {
    const [expanded, setExpanded] = useState<boolean>(false);
    const { notification, removeNotification } = useNotificationHelper();
    const isAuthorized = useAppSelector((state: any) => state.authRoles.isAuthorized);
    const codeMgmtIsEnabled = useAppSelector((state: any) => state.environment.values.codeMgmtIsEnabled);
    const dispatch = useAppDispatch();
    function handleClickOpen() {
        expanded ? setExpanded(false) : setExpanded(true);
    }

    useEffect(() => {
        if (!isAuthorized) {
            dispatch(validateUserRoles());
        }
    }, [isAuthorized, dispatch])


    return (
        isAuthorized ? (
            <div className="private-page" >
                <a id="skip-nav" className="skiplink-text" href="#main-content">
                    Skip to Main Content
                </a>
                <>
                    {notification.message ? (
                        <Notification type={notification.type} closeNotification={() => removeNotification()}>
                            {notification.message}
                        </Notification>
                    ) : null}
                    <PrivateHeader toggleDrawer={handleClickOpen} drawerStatus={expanded} />
                    <StateDrawer expanded={expanded} codeMgmtIsEnabled={codeMgmtIsEnabled}>
                        <div className="body" role="main" id="main-content">
                            {props.children}
                        </div>
                    </StateDrawer>
                </>
            </div>
        ) : (
            <RulesPage />
        )
    )
}

export default PrivatePageLayout;